import React, { useState } from "react";
import { Snippet, Spinner, Button, Link, Image } from "@heroui/react";
import {
  ButtonGroup,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "@heroui/react";
import { IconChevronDown, IconCopy } from "@tabler/icons-react";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import "@/styles/scrollbar.css";
import SimpleBar from "simplebar-react";

type MergeOption = "link" | "sim" | "rebase";

function getShareLink(deckString: string) {
  return `${process.env.NEXT_PUBLIC_BASE_URL}/deckbuilder?deck=${deckString}`;
}

function getSimText(deckString: string) {
  return deckString.replaceAll(";", "\n");
}

export default function Export({
  deck,
  className = "",
}: {
  deck: any;
  className?: string;
}) {
  const [copyText, setCopyText] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<Set<MergeOption>>(
    new Set(["link" as MergeOption]),
  );

  const descriptionsMap = {
    link: "",
    sim: "",
    // rebase: "",
  };

  const labelsMap = {
    link: "Link",
    sim: "Sim",
    // rebase: "Rebase and merge",
  };

  const selectedOptionValue = Array.from(selectedOption)[0];

  const handlePress = () => {
    if (selectedOptionValue === "link") {
      navigator.clipboard.writeText(getShareLink(deck.getDecklist()));
      console.log("copied");
      setCopyText("Copied!");
      setTimeout(() => {
        setCopyText("");
      }, 1000);
    } else if (selectedOptionValue === "sim") {
      navigator.clipboard.writeText(getSimText(deck.getDecklist(false)));
      console.log("copied");
      setCopyText("Copied!");
      setTimeout(() => {
        setCopyText("");
      }, 1000);
    }
  };

  let displayText;
  if (copyText) {
    displayText = copyText;
  } else if (selectedOptionValue === "link") {
    displayText = getShareLink(deck.getDecklist());
  } else if (selectedOptionValue === "sim") {
    displayText = getSimText(deck.getDecklist(false));
  }

  return (
    <div className="flex flex-row flex-wrap items-center gap-2">
      <div
        style={{
          maxWidth: `calc(100svw - 36px - 10px - 8px - 20px)`,
          width: "100%",
        }}
      >
        <div className="flex flex-row w-full">
          <SimpleBarReact className="w-full">
            <Snippet
              onClick={() => handlePress()}
              color={copyText ? "success" : "default"}
              //   variant="flat"
              hideSymbol
              hideCopyButton
              className={
                copyText
                  ? "rounded-tr-none rounded-br-none text-sm grow text-center flex justify-center"
                  : "rounded-tr-none rounded-br-none text-sm grow text-center"
              }
              style={{ maxWidth: "500px" }}
            >
              <span>{displayText}</span>
            </Snippet>
          </SimpleBarReact>
          <Button
            isIconOnly
            //   variant="flat"
            className="rounded-none min-h-0 h-[32px] min-w-[32px] w-[32px]"
            onPress={() => handlePress()}
          >
            <IconCopy height={18} width={18} />
          </Button>
          <Dropdown>
            <DropdownTrigger>
              <Button
                isIconOnly
                className="rounded-tl-none rounded-bl-none min-h-0 h-[32px] min-w-[28px] w-[28px]"
              >
                <IconChevronDown height={18} width={18} />
              </Button>
            </DropdownTrigger>
            <DropdownMenu
              disallowEmptySelection
              aria-label="Share options"
              selectedKeys={selectedOption}
              selectionMode="single"
              onSelectionChange={setSelectedOption as any}
              className="max-w-[300px]"
            >
              <DropdownItem key="link">{labelsMap["link"]}</DropdownItem>
              <DropdownItem key="sim" description={descriptionsMap["sim"]}>
                {labelsMap["sim"]}
              </DropdownItem>
              {/* <DropdownItem
                  key="rebase"
                  //   description={descriptionsMap["rebase"]}
                >
                  {labelsMap["rebase"]}
                </DropdownItem> */}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

{
  /* <Link href={`gumgum.gg/deckbuilder?deck=${getDecklist()}`}>
<Button
  startContent={<IconEdit height={18} width={18} />}
  radius="sm"
  className="mb-4"
  color="secondary"
>
  Edit Deck
</Button>
</Link> */
}

// function getDecklist() {
//   let cardsStr = "";
//   let cardsMap: Record<string, number> = {};
//   if (decklist && decklist.decklist && decklist.decklist.length > 0) {
//     const leaderId = getLeaderId(decklist.leader);
//     cardsMap[leaderId] = 1;
//     cardsStr += `1x${leaderId};`;
//     for (const card of decklist.decklist.split(";")) {
//       const count = parseInt(card.split("x")[0]);
//       const cardId = card.split("x")[1];
//       if (card.includes("DON")) {
//         continue;
//       }
//       let cardNoAA: string = cardId;
//       if (cardId.includes("_p")) {
//         cardNoAA = cardId.split("_")[0];
//       }
//       cardsStr += `${count}x${cardNoAA};`;
//       if (!(cardNoAA in cardsMap)) {
//         cardsMap[cardNoAA] = count;
//       }
//     }

//     const sortedEntries = Object.entries(cardsMap).sort(([keyA], [keyB]) =>
//       keyA.localeCompare(keyB),
//     );
//     let cardsList = sortedEntries.map((value) => {
//       return `${value[1]}x${value[0]}`;
//     });
//   }
//   return cardsStr;
// }
